import { styled } from 'styled-components';
import { Utils } from 'team-hero-ui';

const { pxToRem, flexFn } = Utils;

export const ImagesContainerStyled = styled.div`
  ${flexFn('flex-start')};
  overflow: auto;
`;

export const UploadFileContainerStyled = styled.div`
  margin-bottom: ${pxToRem(35)};
  padding: ${pxToRem([0, 25])};
`;
